import { useOptionalAuth } from '../auth/AuthContext';
import { Tooltip } from './Tooltip';

/** Иконка «?» с пояснением для полей формы и KPI. */
export function InfoHint({ text }: { text: string }) {
  const auth = useOptionalAuth();

  if (auth?.user?.show_ui_hints === false) return null;

  return (
    <Tooltip label={text}>
      <span
        className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-surface-2 text-caption text-text-tertiary hover:text-text-secondary"
        aria-label="Подсказка"
      >
        ?
      </span>
    </Tooltip>
  );
}
